import React from 'react';
import styled from '@emotion/styled';
import { Css } from '@/ui';
import { IMenuItemEntry } from '../../../../contentful/types/IMenuItem';
import { useCommonData } from '../../../../common-data/useCommonData';
import { getMenuItemMapping } from '../../../../utils/getMenuItemMapping';
import { IMenuItemNavBar } from '../../../../contentful/types/IMenuItemNavBar';

import { StyledSubmenuItem } from '../shared/SubNavigation';

interface IMobileNavigationSubmenuItems {
	subMenuItems: IMenuItemEntry[];
}

export default function MobileNavigationSubmenuItems({
	subMenuItems,
}: IMobileNavigationSubmenuItems) {
	const { pathToPageIdMap } = useCommonData();
	const menuItems = getMenuItemMapping(pathToPageIdMap, subMenuItems);

	if (!menuItems) {
		return null;
	}

	return (
		<>
			{menuItems.map((subItem: IMenuItemNavBar) => (
				<SubmenuItemWrapStyled key={subItem.id}>
					<StyledSubmenuItem href={subItem.url}>
						{subItem.title}
					</StyledSubmenuItem>
				</SubmenuItemWrapStyled>
			))}
		</>
	);
}

const SubmenuItemWrapStyled = styled.div`
	display: flex;
	flex-direction: column;
	font-weight: 400;
	margin: ${Css.pxToRem(16)};
	padding-top: 0;
	margin-left: 0;
`;
